export enum RadarDetectionEntityType {
  HTTP_PARAM_DETECTION = 'HTTP_PARAM_DETECTION',
  DETECTION = 'DETECTION'
}
